import { all, fork, call, put, takeLatest } from 'redux-saga/effects';
import {
  Types as ClientTypes,
  Creators as ClientActions,
} from '../ducks/ClientParticipant';
import api from '../../util/Api';
import * as Sentry from '@sentry/react';

function* getClients({ payload }) {
  try {
    const { status, data } = yield call(api.get, '/client-participants', {
      params: payload,
    });
    if (status === 200) {
      yield put(ClientActions.getClientsSuccess(data));
    }
    else {
      Sentry.captureMessage('getClients failed: status not 200', {
        level: 'error',
        extra: { payload, status, data },
      });
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(
      ClientActions.getClientsError('Error listing registrants')
    );
  }
}

function* getClientById({ payload }) {
  try {
    const { status, data } = yield call(api.get, `/client-participants/${payload}`);
    if (status === 200) {
      yield put(ClientActions.getClientByIdSuccess(data));
    }
    else {
      Sentry.captureMessage('getClientById failed: status not 200', {
        level: 'error',
        extra: { payload, status, data },
      });
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(
      ClientActions.getClientByIdError('Error listing registrant')
    );
  }
}

function* postClient({ payload }) {
  try {
    const { status } = yield call(api.post, '/client-participants', payload);
    if (status === 200) {
      yield put(ClientActions.postClientSuccess());
    }
    else {
      Sentry.captureMessage('postClient failed: status not 200', {
        level: 'error',
        extra: { payload, status },
      });
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(
      ClientActions.postClientError('Error registering registrant')
    );
  }
}

function* putClient({ payload }) {
  const { id } = payload;
  try {
    const { status } = yield call(api.put, `/client-participants/${id}`, payload.data);
    if (status === 200) {
      yield put(ClientActions.putClientSuccess());
    }
    else {
      Sentry.captureMessage('putClient failed: status not 200', {
        level: 'error',
        extra: { payload, status },
      });
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(
      ClientActions.putClientError('Error editing registrant')
    );
  }
}


function* deleteClient({ payload }) {
  try {
    const { status } = yield call(api.delete, `/client-participants/${payload}`);
    if (status === 200) {
      yield put(ClientActions.deleteClientSuccess());
    }
    else {
      Sentry.captureMessage('deleteClient failed: status not 200', {
        level: 'error',
        extra: { payload, status },
      });
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(
      ClientActions.deleteClientError('Error deleting registrant')
    );
  }
}

function* getClientsWatcher() {
  yield takeLatest(ClientTypes.GET_CLIENTS, getClients);
}
function* getClientByIdWatcher() {
  yield takeLatest(ClientTypes.GET_CLIENT_BY_ID, getClientById);
}
function* postClientWatcher() {
  yield takeLatest(ClientTypes.POST_CLIENT, postClient);
}
function* putClientWatcher() {
  yield takeLatest(ClientTypes.PUT_CLIENT, putClient);
}
function* deleteClientWatcher() {
  yield takeLatest(ClientTypes.DELETE_CLIENT, deleteClient);
}

export default function* rootSaga() {
  yield all([
    fork(getClientsWatcher),
    fork(postClientWatcher),
    fork(getClientByIdWatcher),
    fork(putClientWatcher),
    fork(deleteClientWatcher),
  ]);
}
